import React from 'react';
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    FormGroup,
    Input,
    Label,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCheckCircle,
    faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons';
import MiniFichaPLD from './MiniFichaPLD';

function nuevaEntidadPLD(rolBase) {
    return {
        id: String(Date.now()) + Math.random().toString(16).slice(2, 6),
        rolBase,
        tipo: 'Fisica',
        nacionalidad: 'México',
        nombre: '',
        paterno: '',
        materno: '',
        rfc: '',
    };
}

export default function ArbolPLD({
    tipoOperacion,
    ningunaFisicaSuperaUmbral,
    verAdminConst,
    setVerAdminConst,
    pldOtroSocio,
    setPldOtroSocio,
    pldFirmante,
    setPldFirmante,
    entidadPLDExtra,
    setEntidadPLDExtra,
    denominacion,
}) {
    if (tipoOperacion === 'CONSTITUTIVA') {
        if (!ningunaFisicaSuperaUmbral) return null;
        return (
            <Card className="mb-4 border-warning shadow-sm">
                <CardHeader className="border-bottom border-warning">
                    <h5 className="mb-0 d-flex align-items-center text-warning">
                        <FontAwesomeIcon
                            icon={faQuestionCircle}
                            className="mr-2"
                        />
                        Regla especial PLD {denominacion ? `de ${denominacion}` : ''}
                    </h5>
                </CardHeader>
                <CardBody>
                    <p className="mb-3">
                        Si tras registrar a todos los participantes ninguna
                        persona física logra superar el 25% del capital, la
                        LFPIORPI exige identificar a la administración.
                    </p>
                    {!verAdminConst && !entidadPLDExtra ? (
                        <Button
                            type="button"
                            color="warning"
                            outline
                            onClick={() => {
                                setVerAdminConst(true);
                                setEntidadPLDExtra(
                                    nuevaEntidadPLD(
                                        'ADMINISTRADOR POR CONTROL (BC)'
                                    )
                                );
                            }}
                        >
                            + Identificar a la administración
                        </Button>
                    ) : null}
                    {verAdminConst && entidadPLDExtra ? (
                        <MiniFichaPLD
                            entidad={entidadPLDExtra}
                            setEntidad={setEntidadPLDExtra}
                            titulo="ADMINISTRADOR POR CONTROL (BC)"
                        />
                    ) : null}
                </CardBody>
            </Card>
        );
    }

    if (tipoOperacion === 'RATIFICACIÓN DE CRÉDITOS') {
        return null;
    }

    if (tipoOperacion === 'INMOBILIARIO') {
        return (
            <Card className="mb-4 border-warning shadow-sm">
                <CardHeader className="border-bottom border-warning">
                    <h5 className="mb-0 d-flex align-items-center text-warning">
                        <FontAwesomeIcon
                            icon={faQuestionCircle}
                            className="mr-2"
                        />
                        Determinación de Beneficiario Controlador
                    </h5>
                </CardHeader>
                <CardBody>
                    <FormGroup>
                        <Label className="font-weight-bold">
                            1. ¿Existe alguna persona que NO comparezca en la
                            operación que tenga el control o se beneficie de la misma?
                        </Label>
                        <div>
                            <FormGroup check inline>
                                <Label check>
                                    <Input
                                        type="radio"
                                        name="pldOtroSocio"
                                        checked={pldOtroSocio === 'si'}
                                        onChange={() => {
                                            setPldOtroSocio('si');
                                            setPldFirmante('');
                                            setEntidadPLDExtra(
                                                nuevaEntidadPLD('BENEFICIARIO CONTROLADOR')
                                            );
                                        }}
                                    />{' '}
                                    Sí
                                </Label>
                            </FormGroup>
                            <FormGroup check inline>
                                <Label check>
                                    <Input
                                        type="radio"
                                        name="pldOtroSocio"
                                        checked={pldOtroSocio === 'no'}
                                        onChange={() => {
                                            setPldOtroSocio('no');
                                            setPldFirmante('');
                                            setEntidadPLDExtra(null);
                                        }}
                                    />{' '}
                                    No
                                </Label>
                            </FormGroup>
                            <FormGroup check inline>
                                <Label check>
                                    <Input
                                        type="radio"
                                        name="pldOtroSocio"
                                        checked={pldOtroSocio === 'omitir'}
                                        onChange={() => {
                                            setPldOtroSocio('omitir');
                                            setPldFirmante('');
                                            setEntidadPLDExtra(null);
                                        }}
                                    />{' '}
                                    Omitir por ahora
                                </Label>
                            </FormGroup>
                        </div>
                    </FormGroup>

                    {pldOtroSocio === 'omitir' ? (
                        <div className="mt-3 p-3 border border-secondary bg-light rounded text-muted font-weight-bold d-flex align-items-center">
                            Determinación de Beneficiario Controlador omitida por
                            ahora; no se guardará ficha PLD adicional.
                        </div>
                    ) : null}

                    {pldOtroSocio === 'si' &&
                        entidadPLDExtra &&
                        (entidadPLDExtra.rolBase || '').includes('BENEFICIARIO CONTROLADOR') ? (
                        <MiniFichaPLD
                            entidad={entidadPLDExtra}
                            setEntidad={setEntidadPLDExtra}
                            titulo="BENEFICIARIO CONTROLADOR"
                        />
                    ) : null}

                    {pldFirmante === 'no' &&
                        entidadPLDExtra &&
                        (entidadPLDExtra.rolBase || '').includes('ADMINISTRADOR') ? (
                        <MiniFichaPLD
                            entidad={entidadPLDExtra}
                            setEntidad={setEntidadPLDExtra}
                            titulo="ADMINISTRADOR POR CONTROL (BC)"
                        />
                    ) : null}
                </CardBody>
            </Card>
        );
    }

    return (
        <Card className="mb-4 border-warning shadow-sm">
            <CardHeader className="border-bottom border-warning">
                <h5 className="mb-0 d-flex align-items-center text-warning">
                    <FontAwesomeIcon
                        icon={faQuestionCircle}
                        className="mr-2"
                    />
                    Determinación de control (pregunta salvavidas PLD)
                </h5>
            </CardHeader>
            <CardBody>
                <FormGroup>
                    <Label className="font-weight-bold">
                        1. ¿Existe algún otro socio que NO comparezca en la
                        operación que tenga más del 25% del capital social?
                    </Label>
                    <div>
                        <FormGroup check inline>
                            <Label check>
                                <Input
                                    type="radio"
                                    name="pldOtroSocio"
                                    checked={pldOtroSocio === 'si'}
                                    onChange={() => {
                                        setPldOtroSocio('si');
                                        setPldFirmante('');
                                        setEntidadPLDExtra(
                                            nuevaEntidadPLD(
                                                'SOCIO HISTÓRICO (>25%)'
                                            )
                                        );
                                    }}
                                />{' '}
                                Sí
                            </Label>
                        </FormGroup>
                        <FormGroup check inline>
                            <Label check>
                                <Input
                                    type="radio"
                                    name="pldOtroSocio"
                                    checked={pldOtroSocio === 'no'}
                                    onChange={() => {
                                        setPldOtroSocio('no');
                                        setPldFirmante('');
                                        setEntidadPLDExtra(null);
                                    }}
                                />{' '}
                                No
                            </Label>
                        </FormGroup>
                        <FormGroup check inline>
                            <Label check>
                                <Input
                                    type="radio"
                                    name="pldOtroSocio"
                                    checked={pldOtroSocio === 'omitir'}
                                    onChange={() => {
                                        setPldOtroSocio('omitir');
                                        setPldFirmante('');
                                        setEntidadPLDExtra(null);
                                    }}
                                />{' '}
                                Omitir por ahora
                            </Label>
                        </FormGroup>
                    </div>
                </FormGroup>

                {pldOtroSocio === 'omitir' ? (
                    <div className="mt-3 p-3 border border-secondary bg-light rounded text-muted font-weight-bold d-flex align-items-center">
                        Determinación de control omitida por ahora; no se
                        guardará ficha PLD adicional.
                    </div>
                ) : null}

                {pldOtroSocio === 'si' &&
                    entidadPLDExtra &&
                    (entidadPLDExtra.rolBase || '').includes('HISTÓRICO') ? (
                    <MiniFichaPLD
                        entidad={entidadPLDExtra}
                        setEntidad={setEntidadPLDExtra}
                        titulo="SOCIO HISTÓRICO (>25%)"
                    />
                ) : null}

                {pldOtroSocio === 'no' ? (
                    <FormGroup className="pt-3 mt-3 border-top border-warning">
                        <Label className="font-weight-bold">
                            2. ¿Alguno de los que firman tiene más del 25%?
                        </Label>
                        <div>
                            <FormGroup check inline>
                                <Label check>
                                    <Input
                                        type="radio"
                                        name="pldFirmante"
                                        checked={pldFirmante === 'si'}
                                        onChange={() => {
                                            setPldFirmante('si');
                                            setEntidadPLDExtra(null);
                                        }}
                                    />{' '}
                                    Sí
                                </Label>
                            </FormGroup>
                            <FormGroup check inline>
                                <Label check>
                                    <Input
                                        type="radio"
                                        name="pldFirmante"
                                        checked={pldFirmante === 'no'}
                                        onChange={() => {
                                            setPldFirmante('no');
                                            setEntidadPLDExtra(
                                                nuevaEntidadPLD(
                                                    'ADMINISTRADOR POR CONTROL (BC)'
                                                )
                                            );
                                        }}
                                    />{' '}
                                    No
                                </Label>
                            </FormGroup>
                        </div>
                    </FormGroup>
                ) : null}

                {pldFirmante === 'si' ? (
                    <div className="mt-3 p-3 border border-success bg-success-soft rounded text-success font-weight-bold d-flex align-items-center">
                        <FontAwesomeIcon
                            icon={faCheckCircle}
                            className="mr-2"
                        />
                        Cumplimiento PLD completado (se armarán sus expedientes
                        con la captura principal).
                    </div>
                ) : null}

                {pldFirmante === 'no' &&
                    entidadPLDExtra &&
                    (entidadPLDExtra.rolBase || '').includes('ADMINISTRADOR') ? (
                    <MiniFichaPLD
                        entidad={entidadPLDExtra}
                        setEntidad={setEntidadPLDExtra}
                        titulo="ADMINISTRADOR POR CONTROL (BC)"
                    />
                ) : null}
            </CardBody>
        </Card>
    );
}
